import { CSSObject, DefaultTheme } from "styled-components";
import { useTheme } from "../Theme/ThemeProvider";
import { vfxTheme } from "../Theme/theme";

interface ChipStyles {
    root: CSSObject;
}

interface ChipStylesProps {
    colortext?: string;
    backgroundcolor?: string;
}

const useChipStyles = (props: ChipStylesProps): ChipStyles => {
    
    return {
        root: {
            color: props.colortext ?? "#555A63",
            backgroundColor: props.backgroundcolor ?? "#E6E7E9",
            fontWeight: vfxTheme.fontWeights.semiBold,
            padding: "1em",
            
        },
    };
};

export default useChipStyles;
